<template>
  <v-form ref="registerForm" v-model="valid" lazy-validation @submit.prevent="singUp">
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="firstName"
          :rules="[rules.required]"
          label="Nome"
          name="firstName"
          autocomplete="given-name"
          maxlength="20"
          variant="outlined"
          density="comfortable"
          rounded="lg"
          prepend-inner-icon="mdi-account-outline"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="lastName"
          :rules="[rules.required]"
          label="Sobrenome"
          name="lastName"
          autocomplete="family-name"
          maxlength="20"
          variant="outlined"
          density="comfortable"
          rounded="lg"
          prepend-inner-icon="mdi-account-outline"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="E-mail"
          type="email"
          name="email"
          autocomplete="username"
          variant="outlined"
          density="comfortable"
          rounded="lg"
          prepend-inner-icon="mdi-email-outline"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="password"
          :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          label="Senha"
          autocomplete="new-password"
          :hint="passwordHin"
          variant="outlined"
          density="comfortable"
          rounded="lg"
          prepend-inner-icon="mdi-lock-outline"
          counter
          @click:append-inner="show1 = !show1"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="verify"
          :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, passwordMatch]"
          :type="show1 ? 'text' : 'password'"
          name="input-10-2"
          label="Confirmar senha"
          autocomplete="new-password"
          variant="outlined"
          density="comfortable"
          rounded="lg"
          prepend-inner-icon="mdi-lock-check-outline"
          counter
          @click:append-inner="show1 = !show1"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          type="submit"
          block
          size="large"
          color="#CF122E"
          rounded="lg"
          :loading="isLoading"
          class="mt-2 text-none text-white font-weight-bold"
        >
          Registrar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';
import { PROD_SECTOR_ID, USER_ROLE } from '@/helpers/constants/app.constants';

export default {
  data: () => ({
    isLoading: false,
    valid: true,
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    verify: '',
    emailRules: [
      (v) => !!v || 'Campo obrigatório.',
      (v) => /.+@.+\..+/.test(v) || 'Favor inserir um e-mail válido.',
    ],
    show1: false,
    rules: {
      required: (value) => !!value || 'Campo obrigatório.',
      min: (v) => (v
          && v.length >= 8
          && /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(
            v,
          ))
        || 'Mín. 8 caracteres (1 maiúsculo, 1 minúsculo, 1 número, 1 caractere especial)',
    },
  }),

  computed: {
    passwordMatch() {
      return () => this.password === this.verify || 'As senhas devem ser iguais.';
    },

    passwordHin() {
      return 'Mín. 8 caracteres (1 maiúsculo, 1 minúsculo, 1 número, 1 caractere especial)';
    },
  },

  methods: {
    ...mapActions('user', ['register']),

    async singUp() {
      const { valid } = await this.$refs.registerForm.validate();
      if (valid) {
        this.isLoading = true;
        const { success } = await this.register({
          email: this.email,
          password: this.password,
          firstName: this.firstName.toUpperCase(),
          lastName: this.lastName.toUpperCase(),
          role: USER_ROLE.GENERAL.id,
          access: false,
          sectorId: PROD_SECTOR_ID
        });
        this.isLoading = false;

        if (success) {
          this.$emit('signup-success');
          this.$router.push({ path: '/' });
        } else {
          this.$emit('signup-fail');
        }
      }
    },
    reset() {
      this.$refs.registerForm.reset();
    },

    resetValidation() {
      this.$refs.registerForm.resetValidation();
    },
  }
}
</script>
